module.exports = __webpack_public_path__ + "static/Hopin-b3cce90ffb15edf50a4610aeed016fc6.jpg";